import { Button, Statement } from '@circlefin/components'
import { approvalSettingsGroupSection } from '@services/sections/lib/approvalSettings'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

import type { User } from '@shared/graphql'

interface UserRemovalGroupRestrictionProps {
  /**
   * The user object .
   */
  user: User
  /**
   * The children to render.
   */
  children: React.ReactNode
}

export const UserRemovalGroupRestriction: React.FC<
  UserRemovalGroupRestrictionProps
> = ({ user, children }) => {
  const { t } = useTranslation('settings')

  if (user.hasGroupRemovalRestriction === true) {
    return (
      <Statement
        status="info"
        subtitle={t('userRemovalGroupRestriction.description')}
        title={t('userRemovalGroupRestriction.title')}
      >
        <Button.Link
          anchorComponent={Link}
          href={approvalSettingsGroupSection.route}
          variant="primary"
        >
          {t('userRemovalGroupRestriction.cta')}
        </Button.Link>
      </Statement>
    )
  }

  return <>{children}</>
}
